import React, { useState } from 'react';
import LanguageContext from './contexts/LanguageContext';
import SEOHead from './components/SEOHead';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  const [language, setLanguage] = useState('en');

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      <SEOHead />
      <div className="App min-h-screen flex flex-col">
        <Header />
        <Hero />
        <Features />
        <HowItWorks />
        <Benefits />
        <CTA />
        <Footer />
      </div>
    </LanguageContext.Provider>
  );
}

export default App;
